import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './app.tsx';
import store from '@store/index.ts';

createRoot(document.getElementById('root')!).render(
    <BrowserRouter basename={import.meta.env.VITE_BASE_URL}>
        <Provider store={store}>
            <App />
        </Provider>
    </BrowserRouter>
);
